jQuery(document).ready(function ($) {

    var pathname = window.location.pathname;
    const variantTitleArr = [];
    var productTitle;
    //----------- Fetching product details--------------------------//
      $.getJSON(pathname+'/products.json', function(response) {
             //console.log("response data",response);
             //console.log("variants",response.product.variants);
             //console.log("title",response.product.title);
        //--------- getting the product title-----------------//
             productTitle = response.product.title;
        //-------------pushing the variant title inside an array---------//
             $.each(response.product.variants, function(key,value) {
                  variantTitleArr.push(value.title);
             });
      });

      $("body").on("click", "#popup-sizeguide", function(event) {
    
        //-------------if condition to check the product title and assign the product variant name------------//
        if(productTitle == 'Xersizer Pro X' || productTitle == 'Xersizer Pro X Essentials Kit' || productTitle == 'Xersizer Pro X VIP Bundle'){
          // $("#prod-name-one").text('Xersizer Pro '+variantTitleArr[0]+' X');
          // $("#prod-name-two").text('Xersizer Pro '+variantTitleArr[1]+' X');
          // $("#prod-name-three").text('Xersizer Pro '+variantTitleArr[2]+' X');

          $("#prod-name-one").text('Xersizer Pro '+variantTitleArr[1]+' X');
          $("#prod-name-two").text('Xersizer Pro '+variantTitleArr[0]+' X');
          $("#prod-name-three").text('Xersizer Pro '+variantTitleArr[2]+' X');
          
        }else if(productTitle == 'Xersizer Pro' || productTitle == 'Xersizer Pro Essentials Kit' || productTitle == 'Xersizer Pro VIP Bundle'){
          $("#prod-name-one").text('Xersizer Pro '+variantTitleArr[1]);
          $("#prod-name-two").text('Xersizer Pro '+variantTitleArr[0]);
          $("#prod-name-three").text('Xersizer Pro '+variantTitleArr[2]);
        }
    
        //-------------- to show the size guide modal pop up on click-------------//
           $("#pp-sizeguide").show();
      });
  
      $("body").on("click", "#close", function(event) {
    
        $("#pp-sizeguide").hide();
      
      });
});